/** CapsuleMesh resource slice: claims the type name, re-exports its decode. */
import { registerGenericResourceSlice } from '../../sliceRegistration.js';
registerGenericResourceSlice('capsulemesh', ['CapsuleMesh']);
//# sourceMappingURL=index.js.map